import React from "react"
import "../components/global-styles/styles.css"
import { Helmet } from "react-helmet";

import LandingHeader from "../components/header/header.component"
import LandingHero from "../components/hero/hero.compontent"
import LandingFooter from "../components/footer/footer.component"
import LandingSection from "../components/landing-section/landing-section.component"

const IndexPage = () => (
  <>
    <Helmet>
      <html lang="pt-BR" />
      <title>Quickfin - Antecipação de Recebíveis</title>
        <meta name="description" content="​A Quickfin conta com a participação do Banco BTG Pactual, o maior banco de investimentos da América Latina, aportando a solidez e confiança que só uma instituição financeira com mais de 10 anos nesse mercado pode trazer. Venha conosco transformar o processo de antecipação de recebíveis com autonomia, transparência e informação acessível por meio de uma experiência simples, digital e ágil." />
        <meta name="description" property="og:description" content="​A Quickfin conta com a participação do Banco BTG Pactual, o maior banco de investimentos da América Latina, aportando a solidez e confiança que só uma instituição financeira com mais de 10 anos nesse mercado pode trazer. Venha conosco transformar o processo de antecipação de recebíveis com autonomia, transparência e informação acessível por meio de uma experiência simples, digital e ágil." />
        <meta property="og:type" content="business.business"/>
        <meta property="og:title" content="Quickfin"/>
        <meta property="og:url" content="https://www.btgmaisbusiness.com.br/"/>
        <link rel="shortcut icon" href="/static/favicon/favicon.ico"></link>
    </Helmet>
    <LandingHeader />
    <main>
      <LandingHero />
      <LandingSection />
    </main>
    <LandingFooter />
  </>
)

export default IndexPage
